<form *ngIf="profileDetailsModel" class="form" #profileDetailsForm="ngForm" novalidate>
    <div class="field">
        <div class="r-form-group">
            <label class="title" for="nameOfAccountOwner">{{'PROFILE_DETAILS.NAME_OF_ACCOUNT_OWNER' |
                translate}}</label>
            <input type="text" autocomplete="off" name="nameOfAccountOwner" #nameOfAccountOwner="ngModel"
                [(ngModel)]="profileDetailsModel.ManagerDetails.ManagerName" [required]="true">
        </div>
        <div *ngIf="profileDetailsForm.submitted || profileDetailsForm.controls['nameOfAccountOwner']?.touched">
            <div *ngIf="profileDetailsForm.controls['nameOfAccountOwner']?.errors?.required" class="error-required">
                {{'ERRORS.REQUIRED' | translate}}
            </div>
        </div>
    </div>
    <div class="field">
        <div class="r-form-group">
            <label class="title">{{'PROFILE_DETAILS.BUSINESS_NAME' | translate}}</label>
            <input type="text" autocomplete="off" name="businessName"
                [(ngModel)]="profileDetailsModel.BusinessDetails.BusinessName" #businessName="ngModel"
                [required]="true">
        </div>
        <div *ngIf="profileDetailsForm.submitted || profileDetailsForm.controls['businessName']?.touched">
            <div *ngIf="profileDetailsForm.controls['businessName']?.errors?.required" class="error-required">
                {{'ERRORS.REQUIRED' | translate}}
            </div>
        </div>
    </div>
    <div class="countryAndCity">
        <div class="r-form-group field" style="width: 48%;">
            <label class="title" for="country">{{'PROFILE_DETAILS.COUNTRY' | translate}}</label>
            <p-autoComplete *ngIf="_allCountries?.length>0" [suggestions]="countries" name="country" #country="ngModel"
                [(ngModel)]="profileDetailsModel.BusinessDetails.Country" [dropdown]="true"
                (completeMethod)="filterCountries($event)" dropdownMode="current" [maxlength]="30" [required]="true">
            </p-autoComplete>
            <input *ngIf="!_allCountries?.length" type="text" name="country" #country="ngModel"
                [(ngModel)]="profileDetailsModel.BusinessDetails.Country" [maxlength]="30" [required]="true" />

            <div *ngIf="profileDetailsForm.submitted || profileDetailsForm.controls['country']?.touched">
                <div *ngIf="profileDetailsForm.controls['country']?.errors?.required" class="error">
                    {{'ERRORS.REQUIRED' | translate}}
                </div>
                <div *ngIf="profileDetailsForm.controls['country']?.errors?.maxlength" class="error">
                    {{'ERRORS.MAX_LENGTH' | translate}} 30
                </div>
            </div>
        </div>
        <div class="field">
            <div class="r-form-group autocomplete">
                <label class="title" for="city">{{'PROFILE_DETAILS.CITY' | translate}}</label>
                <p-autoComplete name="city" [(ngModel)]="profileDetailsModel.BusinessDetails.City" #city="ngModel"
                    [suggestions]="cities" [dropdown]="true" (completeMethod)="filterCities($event)" [required]="true">
                </p-autoComplete>
            </div>
            <div *ngIf="profileDetailsForm.submitted || profileDetailsForm.controls['city']?.touched">
                <div *ngIf="profileDetailsForm.controls['city']?.errors?.required" class="error-required">
                    {{'ERRORS.REQUIRED' | translate}}
                </div>
            </div>
        </div>
    </div>
    <div class="field">
        <div class="r-form-group ">
            <label class="title" for="street">{{'PROFILE_DETAILS.STREET' | translate}}</label>
            <input type="text" name="street" #street="ngModel" [(ngModel)]="profileDetailsModel.BusinessDetails.Street"
                [required]="true">
        </div>
        <div *ngIf="profileDetailsForm.submitted || profileDetailsForm.controls['street']?.touched">
            <div *ngIf="profileDetailsForm.controls['street']?.errors?.required" class="error-required">
                {{'ERRORS.REQUIRED' | translate}}
            </div>
        </div>
    </div>
    <div class="field">
        <div class="r-form-group ">
            <label class="title" for="category">{{'REGISTER.BUSINESS_AERA' | translate}}</label>
            <p-dropdown name="category" [appendTo]="null" [options]="bussinessCategory"
                [(ngModel)]="profileDetailsModel.BusinessDetails.CategoryId" #category="ngModel"
                optionLabel="description" (ngModelChange)="profileDetailsModel.BusinessDetails.CategoryId=$event"
                [filter]="true" filterBy="label" placeholder="{{'REGISTER.CHOOSE_BUSINESS_AREA' | translate}}"
                [showClear]="true">
            </p-dropdown>
            <div *ngIf="profileDetailsForm.submitted && !category.valid" class="error-required">
                {{'ERRORS.REQUIRED' | translate}}
            </div>
        </div>
        <div class="r-form-group ">
            <div *ngIf="profileDetailsModel.BusinessDetails.CategoryId?.value==BusinessCategory.other"
                class="r-form-group ">
                <input name="details" type="text" [(ngModel)]="profileDetailsModel.BusinessDetails.Details"
                    #details="ngModel" placeholder="{{'REGISTER.ENTER_BUSINESS_AREA'| translate}}" pInputText
                    maxlength=200>
            </div>
        </div>
    </div>
    <div class="field">
        <div class="r-form-group ">
            <label class="title" for="phone">{{'PROFILE_DETAILS.PHONE' | translate}}</label>
            <input type="text" name="phone" #phone="ngModel" [(ngModel)]="profileDetailsModel.BusinessDetails.Phone"
                [required]="true">
        </div>
        <div *ngIf="profileDetailsForm.submitted || profileDetailsForm.controls['phone']?.touched">
            <div *ngIf="profileDetailsForm.controls['phone']?.errors?.required" class="error-required">
                {{'ERRORS.REQUIRED' | translate}}
            </div>
        </div>
    </div>
    <div class="field">
        <div class="r-form-group ">
            <label class="title" for="email">{{'PROFILE_DETAILS.EMAIL' | translate}}</label>
            <input type="text" name="email" #email="ngModel" [(ngModel)]="profileDetailsModel.ManagerDetails.Email"
                required disabled="true">
        </div>
        <div *ngIf="profileDetailsForm.submitted && !email.valid" class="error-required">
            {{'ERRORS.REQUIRED' | translate}}
        </div>
    </div>

    <div class="field">
        <div class="r-form-group">
            <label class="title" for="web_site">{{'PROFILE_DETAILS.WEB_SITE' | translate}}</label>
            <input type="text" autocomplete="off" name="web_site" #web_site="ngModel"
                [(ngModel)]="profileDetailsModel.BusinessDetails.WebSite" maxlength="200">
        </div>
        <div *ngIf="web_site?.errors?.maxlength" class="error-required">
            {{'ERRORS.MAX_LENGTH' | translate}}
        </div>
    </div>
    <div class="field">
        <div class="r-form-group ">
            <label class="title" for="language">{{'PROFILE_DETAILS.LANGUAGE' | translate}}</label>
            <p-dropdown name="language" [appendTo]="null" #language="ngModel"
                [(ngModel)]="profileDetailsModel.BusinessDetails.Language" [options]="languages" class="langDrop">
                <ng-template pTemplate="selectedItem">
                    {{profileDetailsModel.BusinessDetails.Language|enumTranslate:lang}}
                </ng-template>
                <ng-template let-item pTemplate="item">
                    {{item|enumTranslate:lang}}
                </ng-template>
            </p-dropdown>
        </div>
        <div *ngIf="profileDetailsForm.submitted && !language.valid" class="error-required">
            {{'ERRORS.REQUIRED' | translate}}
        </div>
    </div>
    <change-password [hasPassword]="hasPassword" (passwordUpdated)="onPasswordUpdated($event)"></change-password>
    <button class="command-button full full-width" type="button"
        (click)="changePasswordDialog.showChangePasswordDialog()">
        {{ hasPassword ? ('CHANGE_PASSWORD.SAVE' | translate) : ('CHANGE_PASSWORD.SET_PASSWORD' | translate) }}
    </button>
    <button class="command-button full full-width" type="submit" blockButtonToSingleClick
        [disabled]="!profileDetailsForm.form.valid || !profileDetailsForm.form.touched"
        (click)="saveForm()">{{'PROFILE_DETAILS.SAVE_CHANGES' |translate}}</button>
    <button class="command-button full full-width" type="submit"
        (click)="logout()">{{'PROFILE_DETAILS.LOGOUT_THE_ACCOUNT' | translate}}</button>
</form>